@import 'styles/mixins';

.dropdownContainer {
  display: flex;
  flex-direction: column;
  padding: 4px;
  width: 206px;
}

.divider {
  margin: 4px auto;
  min-width: 100%;
  max-width: 100%;
  min-height: 1px;
}

.shortcutKey {
  background-color: var(--neutral-5);
  color: var(--neutral-50);
}

.lastEdited {
  @include sm-medium;
  color: var(--neutral-40);
  padding: 8px 8px 4px 8px;

  .name {
    @include line-clamp;
  }
}
